import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'loading-dialog',
  template: ` <div class="loading-circle"></div> `,
})
export class CasinoLoadingDialog {
  constructor(public dialogRef: MatDialogRef<CasinoLoadingDialog>) {}
}
